import React, { FC } from 'react'

// Lucide icons (AlertTriangle, CreditCard, WifiOff) inlined so the pop-up uses the mock's exact glyphs.
interface IconProps {
  size?: number
  className?: string
}

const LucideIcon: FC<IconProps> = ({ size = 24, className, children }) => (
  <svg
    aria-hidden='true'
    className={className}
    fill='none'
    focusable='false'
    height={size}
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth={2}
    viewBox='0 0 24 24'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    {children}
  </svg>
)

export const AlertTriangleIcon: FC<IconProps> = props => (
  <LucideIcon {...props}>
    <path d='m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3' />
    <path d='M12 9v4' />
    <path d='M12 17h.01' />
  </LucideIcon>
)

export const CreditCardIcon: FC<IconProps> = props => (
  <LucideIcon {...props}>
    <rect
      height='14'
      rx='2'
      width='20'
      x='2'
      y='5'
    />
    <line
      x1='2'
      x2='22'
      y1='10'
      y2='10'
    />
  </LucideIcon>
)

export const WifiOffIcon: FC<IconProps> = props => (
  <LucideIcon {...props}>
    <path d='M12 20h.01' />
    <path d='M8.5 16.429a5 5 0 0 1 7 0' />
    <path d='M5 12.859a10 10 0 0 1 5.17-2.69' />
    <path d='M19 12.859a10 10 0 0 0-2.007-1.523' />
    <path d='M2 8.82a15 15 0 0 1 4.177-2.643' />
    <path d='M22 8.82a15 15 0 0 0-11.288-3.764' />
    <path d='m2 2 20 20' />
  </LucideIcon>
)
